export const PIPELINE_STAGES = [
  { value: 'received', label: 'Received' },
  { value: 'counsellor_assigned', label: 'Counsellor Assigned' },
  { value: 'college_assigned', label: 'College Assigned' },
  { value: 'sent_to_college', label: 'Sent to College' },
  { value: 'loa_received', label: 'LOA Received' },
  { value: 'noa_received', label: 'NOA Received' },
  { value: 'student_aid_started', label: 'Student Aid Application Started' },
  { value: 'enrollment_contract_signed', label: 'Enrollment Contract Signed' },
  { value: 'cancelled', label: 'Cancelled' },
  { value: 'withdrawn', label: 'Withdrawn' },
  { value: 'invoice_raised_to_college', label: 'Invoice Raised to College by TGE' },
  { value: 'commission_received', label: 'Commission Received from College' },
  { value: 'commission_paid_to_agent', label: 'Commission Paid to Agent' },
];

export const STAGE_LABELS = Object.fromEntries(
  PIPELINE_STAGES.map((s) => [s.value, s.label])
);

const STAGE_COLORS = {
  received: 'bg-slate-50 text-slate-700 border-slate-200',
  counsellor_assigned: 'bg-sky-50 text-sky-700 border-sky-200',
  college_assigned: 'bg-cyan-50 text-cyan-700 border-cyan-200',
  sent_to_college: 'bg-blue-50 text-blue-700 border-blue-200',
  loa_received: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  noa_received: 'bg-purple-50 text-purple-700 border-purple-200',
  student_aid_started: 'bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200',
  enrollment_contract_signed: 'bg-teal-50 text-teal-700 border-teal-200',
  cancelled: 'bg-rose-50 text-rose-700 border-rose-200',
  withdrawn: 'bg-stone-100 text-stone-600 border-stone-200',
  invoice_raised_to_college: 'bg-orange-50 text-orange-700 border-orange-200',
  commission_received: 'bg-amber-50 text-amber-700 border-amber-200',
  commission_paid_to_agent: 'bg-emerald-50 text-emerald-700 border-emerald-200',
};

export function StagePill({ stage, testId }) {
  if (!stage || !STAGE_LABELS[stage]) return null;
  return (
    <span
      className={`inline-block text-[10px] font-semibold px-2 py-0.5 rounded-full border ${STAGE_COLORS[stage] || 'bg-gray-50 text-gray-600 border-gray-200'}`}
      data-testid={testId || `stage-pill-${stage}`}
    >
      {STAGE_LABELS[stage]}
    </span>
  );
}
